import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/f/:folder',
      component: () => import('./views/Folder.vue')
    },
    {
      path: '/f/:folder/:message',
      component: () => import('./views/Folder.vue')
    },
    {
      path: '/login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '*',
      redirect: '/f/inbox'
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  if (!(await Vue.$gmail.user.isSignedIn()) && to.path !== '/login') next('/login');
  if (await Vue.$gmail.user.isSignedIn() && to.path === '/login') next('/f/inbox');
  next();
})

export default router
